const statesRequiringDetailedReview = ['CA', 'NY', 'FL']

const conditionalNextResolvers = {
  /**
   * Determines the next step for the main_reason step when the user selects "other".
   * Uses optional args to read additional funnel data (i.e., state) to support more
   * complex branching.
   */
  mainReasonOtherResolver: ({ selectedValue, funnelData = {}, args = [], condition = {} }) => {
    // if (selectedValue !== 'other') return null

    const [stateField] = args
    const userState = stateField ? funnelData[stateField] : undefined
    const options = condition.options || {}

    const detailedStep = options.detailedStep || 'ask_for_medication_detail'
    const defaultStep = options.defaultStep || detailedStep
    const reviewStates = options.reviewStates || statesRequiringDetailedReview

    if (!reviewStates.length) {
      return detailedStep
    }

    if (userState && reviewStates.includes(userState)) {
      return detailedStep
    }

    return defaultStep
  },
}

export default conditionalNextResolvers

